/* Nano Protection : produits « prix sur demande » (étiquette prix-sur-demande).
   Ils ne peuvent pas rester dans le panier : retrait automatique au chargement, après chaque mise à jour
   du panier et avant tout passage au paiement. Le formulaire de soumission est prérempli avec ?produit=… */
(function () {
  var cfg = window.npProGuard;
  if (!cfg || !window.fetch) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cache = {};
  var running = null;

  function isPro(handle) {
    if (cfg.test.indexOf(handle) !== -1) return Promise.resolve(true);
    if (Object.prototype.hasOwnProperty.call(cache, handle)) return Promise.resolve(cache[handle]);
    return fetch(root + 'products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : { tags: [] }; })
      .then(function (p) {
        var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
        return (cache[handle] = tags.indexOf(cfg.tag) !== -1);
      })
      .catch(function () { return false; });
  }

  function proItems() {
    return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      return Promise.all(cart.items.map(function (i) { return isPro(i.handle); })).then(function (flags) {
        return cart.items.filter(function (_, n) { return flags[n]; });
      });
    });
  }

  function notify() {
    if (document.querySelector('.np-pro-notice')) return;
    var d = document.createElement('div');
    d.className = 'np-pro-notice';
    d.setAttribute('role', 'alert');
    d.style.cssText = 'position:fixed;left:16px;right:16px;bottom:16px;z-index:2147483000;max-width:560px;margin:0 auto;padding:16px 48px 16px 18px;background:#053e61;color:#fff;border-radius:12px;box-shadow:0 10px 30px rgba(0,0,0,.25);font-size:15px;line-height:1.45;';
    d.innerHTML = cfg.removed;
    Array.prototype.forEach.call(d.querySelectorAll('a'), function (a) { a.style.color = '#5bc0eb'; a.style.fontWeight = '600'; });
    var x = document.createElement('button');
    x.type = 'button';
    x.setAttribute('aria-label', cfg.close);
    x.textContent = '×';
    x.style.cssText = 'position:absolute;top:8px;right:10px;background:none;border:0;color:#fff;font-size:24px;line-height:1;cursor:pointer;';
    x.addEventListener('click', function () { d.remove(); });
    d.appendChild(x);
    document.body.appendChild(d);
  }

  // Retire les produits PRO du panier. Résout true si quelque chose a été retiré.
  function enforce() {
    if (running) return running;
    running = proItems().then(function (items) {
      if (!items.length) return false;
      var updates = {};
      items.forEach(function (i) { updates[i.key] = 0; });
      return fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function () {
        try { sessionStorage.setItem('npProRemoved', '1'); } catch (e) {}
        location.reload();
        return true;
      });
    }).catch(function () { return false; }).then(function (r) { running = null; return r; });
    return running;
  }

  // Tout bouton ou lien de paiement : vérifier le panier d'abord
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[name="checkout"], a[href*="/checkout"]');
    if (!el || el.getAttribute('data-np-checked')) return;
    e.preventDefault();
    e.stopPropagation();
    enforce().then(function (removed) {
      if (removed) return;
      el.setAttribute('data-np-checked', '1');
      el.click();
    });
  }, true);

  function init() {
    try { if (sessionStorage.getItem('npProRemoved')) { sessionStorage.removeItem('npProRemoved'); notify(); } } catch (e) {}
    enforce();
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { enforce(); });
    }
    var produit = new URLSearchParams(location.search).get('produit');
    var body = produit && document.querySelector('form#ContactForm textarea, textarea[name^="contact["]');
    if (body && !body.value) body.value = cfg.prefill + ' ' + produit + '\n';
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();